<div class="list-header-container">
    <mat-panel-title (click)="$event.stopPropagation()">
        <p class="title">{{ titleText }}</p>
    </mat-panel-title>
    <mat-panel-description (click)="$event.stopPropagation()">
        @if (buttonDisplayListVisible) {
            <button mat-raised-button class="basic-button management-button" (click)="$event.stopPropagation(); onDisplayList()">
                <fa-icon [icon]="faList"></fa-icon>
                <span class="text-button">Affichage liste</span>
            </button>
        }
        @if (buttonDisplayTreeVisible) {
            <button mat-raised-button class="basic-button management-button" (click)="$event.stopPropagation(); onDisplayTree()">
                <fa-icon [icon]="faFolderTree"></fa-icon>
                <span class="text-button">Affichage arborescence</span>
            </button>
        }

        @if (createRight) {
            <button mat-raised-button class="accent-button management-button" (click)="$event.stopPropagation(); onCreation()">
                <fa-icon [icon]="faAdd"></fa-icon>
                <span class="text-button">{{ createIconText }}</span>
            </button>
        }

        @if (!!importDatasourceName) {
            <button mat-raised-button class="basic-button management-button" (click)="$event.stopPropagation(); fileToUpload.click()">
                <fa-icon [icon]="faFileImport"></fa-icon>
                <span class="text-button">import Excel</span>
                <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
            </button>
        }
        <button mat-raised-button class="basic-button management-button" (click)="$event.stopPropagation(); onExport()">
            <fa-icon [icon]="faFileExport"></fa-icon>
            <span class="text-button">Export Excel</span>
        </button>
        <button mat-raised-button class="basic-button management-button" (click)="$event.stopPropagation(); onHelp()">
            <fa-icon [icon]="faQuestion"></fa-icon>
            <span class="text-button">Aide</span>
        </button>
    </mat-panel-description>
</div>
